import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBike = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M5 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 19l0 -4l-3 -3l5 -4l2 3l3 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" })
	]
});
const ForwardRef = forwardRef(SvgBike);
export default ForwardRef;
